import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
           <p>Copyright &copy; 2020 | Developed By <a href="https://github.com/amitk-singh">Amitsingh</a> </p> 
        </footer>
    )
}

export default Footer;